import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Heading,
} from '@tenancy.nz/design-system';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Markdown from './Markdown';

function AccordionItem({details, expanded, markdown, onChange, title}) {
  return (
    <Accordion expanded={expanded} onChange={onChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Heading as="h6" gutterBottom={false} color="textPrimary">
          {title}
        </Heading>
      </AccordionSummary>
      <AccordionDetails>
        {markdown ? <Markdown>{details}</Markdown> : details}
      </AccordionDetails>
    </Accordion>
  );
}

AccordionItem.propTypes = {
  /**
   */
  details: PropTypes.node.isRequired,

  /**
   */
  expanded: PropTypes.bool,

  /**
   */
  markdown: PropTypes.bool,

  /**
   */
  onChange: PropTypes.func.isRequired,

  /**
   */
  title: PropTypes.node.isRequired,
};

AccordionItem.defaultProps = {
  expanded: false,
  markdown: false,
};

export default AccordionItem;
